import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Parameters } from '../models/parameters';
import { PopupMessage } from '../models/popupMessage';
import { PortalLookups } from '../models/portalLookups';
import { PortalParameters } from '../models/portalParameters';
import { Unsubscriber } from '../models/unsubscriber';
import { ConfirmationPopupMessageService } from '../services/confirmation-popup-message.service';
import { WaitlistService } from '../services/waitlist.service';
import { WaitlistPortalService } from '../services/waitlist-portal.service';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})

export class UnsubscribeComponent {
  params:Parameters = new Parameters();
  portalParams:PortalParameters = new PortalParameters();
  unsubscriber:Unsubscriber = new Unsubscriber();
  resetStatus:string = "";
  formInvalid:boolean = false; 
  unsubscribeReasons:PortalLookups[] = [];  
  popupMessage: PopupMessage = new PopupMessage();
  code:string = "";

  constructor (
      private waitlistService:WaitlistService,
      private waitlistPortalService:WaitlistPortalService,
      private confirmationPopupMessageService: ConfirmationPopupMessageService,
      private router:ActivatedRoute,
      private spinnerService: NgxSpinnerService
  ){
  }

  ngOnInit(){
    this.spinnerService.show();
    this.code = this.router.snapshot.queryParamMap.get('code');

    this.waitlistPortalService.getPortalLookups("UnsubscribeReason").then((data) => {
        this.unsubscribeReasons = data;
    }, (error) => {
        this.spinnerService.hide();
    });
    
    this.spinnerService.hide();
  }


  unsubscribe(f:any){

    if (f.invalid)
        this.formInvalid = true;
    else
    {
        this.waitlistService.getPopupMessages().subscribe((ps) => {
            let popupMsg = ps.filter(p => p.code == "Unsubscribe")[0];
            if (popupMsg)
            {
                this.confirmationPopupMessageService.confirm(popupMsg, "lg").then(result => {
                    if (result == true)
                    {
                        this.spinnerService.show();
                        this.params.phoneNumber = this.unsubscriber.phoneNumber;
                        this.waitlistService.getUnsubscriberByPhone(this.params).subscribe(data=>{
                            if (!data)
                            {
                                this.unsubscriber.unsubscribeType = "Text";
                                this.waitlistService.addUnsubscriber(this.unsubscriber).subscribe(u => {
                                  if (this.unsubscriber.email && this.unsubscriber.email.length > 0)
                                  {
                                    //send an email
                                    
                                  }
                                  this.resetStatus = "success";
                                });
                            }
                            this.resetStatus = "success";
                        });
                        this.spinnerService.hide();
                    }
                });
            }
        });
    }
  }

}
